// async so Gatsby doesn't try to build it at compile time.
export const isLocal = async () => {
    const loc = global.location;
    return (
        loc.hostname === "localhost" || loc.hostname.endsWith(".disappear.at") || loc.hostname.endsWith(".hereby.dev")
    );
};
